export const BIOMES = {
    tutorial: {
        id: 'tutorial',
        name: 'Sector Zero',
        palette: {
            background: '#05050A',
            walls: '#FFFFFF',
            pellets: '#E0FFFF',
        },
        hazards: [],
        enemyMix: ['patroller'],
        contractTypes: ['collect_shards', 'survive_ticks'],
        seedConstraints: {
            minSize: 11,
            maxSize: 15,
            loopPercentage: 0.1,
            density: 'low',
        },
    },
    neon_alley: {
        id: 'neon_alley',
        name: 'Neon Alley',
        palette: {
            background: '#05050A',
            walls: '#00F0FF',
            pellets: '#E0FFFF',
        },
        hazards: [],
        enemyMix: ['hunter', 'patroller'],
        contractTypes: ['collect_shards', 'kill_enemies'],
        seedConstraints: {
            minSize: 15,
            maxSize: 19,
            loopPercentage: 0.05,
            density: 'medium',
        },
    },
    toxic_sewers: {
        id: 'toxic_sewers',
        name: 'Toxic Sewers',
        palette: {
            background: '#0A1405',
            walls: '#39FF14',
            pellets: '#B2FF66',
        },
        hazards: ['acid'],
        enemyMix: ['ambusher', 'snare'],
        contractTypes: ['survive_ticks', 'use_items'],
        seedConstraints: {
            minSize: 19,
            maxSize: 23,
            loopPercentage: 0.02,
            density: 'high',
        },
    },
    core_reactor: {
        id: 'core_reactor',
        name: 'Core Reactor',
        palette: {
            background: '#140505',
            walls: '#FF003C',
            pellets: '#FF9999',
        },
        hazards: ['emp'],
        enemyMix: ['hunter', 'splitter', 'ambusher'],
        contractTypes: ['kill_enemies', 'collect_shards'],
        seedConstraints: {
            minSize: 21,
            maxSize: 25,
            loopPercentage: 0.15,
            density: 'very_high',
        },
    },
};
